import { GameId } from '@bg-shared/enums/GameId';
import { IGameItem } from '@bg-shared/interfaces/IGameItem';
import {
    ILotteryGameRunItem,
    IMappedRunItemCallback,
} from '@bg-shared/business/CurrentResult/interfaces';
import { useCurrentResult } from './useCurrentResult';

const mapData: IMappedRunItemCallback<IGameItem> = (entry) => {
    const item = entry.item as ILotteryGameRunItem;

    return {
        item: {
            number: Number(item.value),
            color: item.color,
            order: item.order,
            drawCode: entry.runCode,
        },
        order: item.order,
    };
};

export const useCurrentLotteryResult = (
    gameId: GameId,
    drawCode: string,
    delay = 0,
    disabled?: boolean,
): IGameItem[] => useCurrentResult<IGameItem>(gameId, drawCode, delay, mapData, disabled);
